import { takeEvery, takeLatest } from 'redux-saga/effects'

const takes = ({ types, sagas }) => [
    takeLatest(types.GET_URL_METADATA, sagas.getUrlMetadata),
    takeEvery(types.GET_URLS_METADATA, sagas.getUrlsMetadata),
]

export default takes
